const SESSION_KEY  = 'ssi_session_id';
const BEACON_PREFIX = 'ssi_beacon:';

const _fired = new Set();

function generateUUID() {
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map(x => x.toString(16).padStart(2, '0'));
  return `${h.slice(0,4).join('')}-${h.slice(4,6).join('')}-${h.slice(6,8).join('')}-${h.slice(8,10).join('')}-${h.slice(10).join('')}`;
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = generateUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return generateUUID();
  }
}

export function fireEvent(type, data) {
  if (_fired.has(type)) return;
  const beaconKey = BEACON_PREFIX + type;
  try {
    if (sessionStorage.getItem(beaconKey)) return;
    sessionStorage.setItem(beaconKey, '1');
  } catch { /* sessionStorage unavailable — module-level dedup still applies */ }
  _fired.add(type);

  const apiBase = import.meta.env.VITE_API_BASE;
  if (!apiBase) return;
  fetch(`${apiBase}/analytics/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, session_id: getSessionId(), data }),
  }).catch(() => {});
}
